import { ThunkType } from "../../../../core/store/reducers";
import getDividendApi from "../api/getdividend";
import { setDisplayed } from "../dividendsDataSlice";
import { DividendData } from "../types";

export const loadDividend = (divid: string): ThunkType => async (
  dispatch,
  getStore
) => {
  dispatch(setDisplayed());

  const dividend = await dispatch(getDividend(divid));

  dispatch(setDisplayed(dividend));
};

export const getDividend = (
  divId: string
): ThunkType<Promise<DividendData | undefined>> => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { userId } = store.data.auth.current.user;
  console.log(divId)
  return await dispatch(getDividendApi(userId, divId));
};
